import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Tic Tac Toe" link="https://upbeat-chirag-tic-tac-toe.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is my project where you can play tic tac toe with your friends.
    </ProjectCard>
    <ProjectCard title="Keeper App" link="https://chirag-keeper-app.netlify.app/" bg="linear-gradient(to left, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is my project that is just like google notes app.
    </ProjectCard>
    <ProjectCard title="Random Choice Picker" link="https://chirag-creator17.github.io/Random-choice-picker/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is my project where you can choose randomly betweed different objects.
    </ProjectCard>
    <ProjectCard title="WhatsApp bot - Mymate" link="https://github.com/Chirag-creator17/CIS-HACK" bg="linear-gradient(to left, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is my project made by me during Hackathon .
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      